// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"4610d0e5","211":"72e3fba0","453":"64be9eb2","494":"fe9581ce","519":"4ea0c809","587":"a34e1672","598":"ddf41005","730":"faa9a047","816":"53dc572b"}[chunkId] + ".chunk.js";
};